/**
 * @description Check if the client token has expired
 */
export function hasTokenExpired(auth) {
  try {
    return auth.tokenDetails.expires < Date.now();
  } catch (e) {
    return false;
  }
}